export function getFileType(file: File): string {
  let rv = (file?.name?.split('/') ?? [])[1];
  const parts = file?.name?.split('.') ?? [];
  rv = parts[parts.length - 1];
  return rv;
}
